<template>
  <div class="col-2">
    <div class="card py-2">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideCard',
}
</script>

<style scoped>
    a {
        color: black;
    }
</style>
